import { SuperBlocks } from '../../../config/certification-settings';
import { ns as MainApp } from './action-types';

export const savedChallengesSelector = state =>
  userSelector(state).savedChallenges || [];
export const completedChallengesSelector = state =>
  userSelector(state).completedChallenges || [];
export const completedChallengeCount = state =>
  userSelector(state).completedChallengeCount || 0;
export const partiallyCompletedChallengesSelector = state =>
  userSelector(state).partiallyCompletedChallenges || [];
export const completionCountSelector = state => state[MainApp].completionCount;
export const currentChallengeIdSelector = state =>
  state[MainApp].currentChallengeId;

export const emailSelector = state => userSelector(state).email;

export const codeRegistrationSelector = state =>
  state[MainApp].codeRegistration;

export const isDonatingSelector = state => userSelector(state).isDonating;
export const isOnlineSelector = state => state[MainApp].isOnline;
export const isServerOnlineSelector = state => state[MainApp].isServerOnline;
export const isSignedInSelector = state => !!state[MainApp].appUsername;
export const isSignoutModalOpenSelector = state =>
  state[MainApp].showSignoutModal;
export const isModalGoToUnlockPageOpenSelector = state => {
  return state[MainApp].showModalGoToUnlockPage;
};
export const recentlyClaimedBlockSelector = state =>
  state[MainApp].recentlyClaimedBlock;
export const signInLoadingSelector = state =>
  userFetchStateSelector(state).pending;
export const showCertSelector = state => state[MainApp].showCert;
export const showCertFetchStateSelector = state =>
  state[MainApp].showCertFetchState;

export const userTokenSelector = state => {
  return userSelector(state).userToken;
};

export const showCodeAllySelector = state => {
  return state[MainApp].showCodeAlly;
};

export const userByNameSelector = username => state => {
  const { user } = state[MainApp];
  // return initial state empty user empty object instead of empty
  // object litteral to prevent components from re-rendering unnecessarily
  // TODO: confirm if "initialState" can be moved here or action-types.js
  return user[username] ?? {};
};

export const currentCertsSelector = state =>
  certificatesByNameSelector(state[MainApp]?.appUsername)(state)?.currentCerts;

export const certificatesByNameSelector = username => state => {
  const {
    isFundamentosDaProgramacaoFrontEndCert,
    isLogicaDeProgramacaoCert,
    isHtmlCssJavascriptCert,
    isReactCert
  } = userByNameSelector(username)(state);
  return {
    currentCerts: [
      {
        show: isFundamentosDaProgramacaoFrontEndCert,
        title: 'Frontend Programming Fundamentals',
        certSlug: SuperBlocks.LogicaDeProgramacao
      },
      {
        show: isLogicaDeProgramacaoCert,
        title: 'Logic Programming Certification',
        certSlug: SuperBlocks.LogicaDeProgramacao
      },
      {
        show: isHtmlCssJavascriptCert,
        title: 'Html, CSS and Javascript Certification',
        certSlug: SuperBlocks.HtmlCssJavascript
      },
      {
        show: isReactCert,
        title: 'React library Certification',
        certSlug: SuperBlocks.React
      }
    ],
    legacyCerts: []
  };
};

export const userFetchStateSelector = state => state[MainApp].userFetchState;
export const allChallengesInfoSelector = state =>
  state[MainApp].allChallengesInfo;
export const userProfileFetchStateSelector = state =>
  state[MainApp].userProfileFetchState;
export const usernameSelector = state => state[MainApp].appUsername;
export const userSelector = state => {
  const username = usernameSelector(state);

  return state[MainApp].user[username] || {};
};

export const messageListSelector = state => {
  return state[MainApp].messageList;
};
export const messagesForAdminSelector = state => {
  return state[MainApp].adminMessages;
};
export const messageForAdminLoadingSelector = state => {
  return state[MainApp].adminMessages.loading;
};
export const messageFormLoadingSelector = state => {
  return state[MainApp].messageForm.loading;
};

export const selectSignInLoading = state => {
  return state[MainApp].loading.signIn;
};

export const selectSignUpLoading = state => {
  return state[MainApp].loading.signUp;
};

export const selectSubscriptionLoading = state => {
  return state[MainApp].loading.subscription;
};

export const selectSentEmailToRecoveryLoading = state => {
  return state[MainApp].loading.sentEmailToRecovery;
};

export const selectUnlockUserAccountLoading = state => {
  return state[MainApp].loading.unlockUserAccount;
};

export const automaticEmailsSelector = state => {
  return state[MainApp].automaticEmails;
};

export const isLoadingAutomaticEmailsSelector = state => {
  return state[MainApp].automaticEmails.loading;
};

export const manualEmailSelector = state => {
  return state[MainApp].manualEmails;
};

export const isLoadingManualEmailsSelector = state => {
  return state[MainApp].manualEmails.loading;
};

export const recurringEmailSelector = state => {
  return state[MainApp].recurringEmail;
};

export const isLoadingRecurringEmailsSelector = state => {
  return state[MainApp].recurringEmail.loading;
};

export const showEmailDrawerSelector = state => {
  return state[MainApp].showEmailDrawer;
};

export const showEditUserDrawerSelector = state => {
  return state[MainApp].showEditUserDrawer;
};

export const quizUserSelector = state => {
  return state[MainApp].quizUser.data;
};

export const quizNationalUserSelector = state => {
  return state[MainApp].quizUser.nationalResponse;
};

export const isLoadingRegisterQuizUserSelector = state => {
  return state[MainApp].quizUser.loading;
};

export const isLoadingChangePasswordSelector = state => {
  return state[MainApp].loading.changePassword;
};

export const isLoadingSubmitAboutSelector = state => {
  return state[MainApp].loading.submitAbout;
};

export const allUsersSelector = state => {
  return state[MainApp].userManagement;
};

export const isLoadingAllUsersSelector = state => {
  return state[MainApp].userManagement.loading;
};

export const isLoadingAllPreEnrolledSelector = state => {
  return state[MainApp].preEnrolled.loading;
};

export const allPreEnrolledSelector = state => {
  return state[MainApp].preEnrolled;
};

export const isLoadingDeleteAccountSlector = state => {
  return state[MainApp].loading.deleteAccount;
};

export const requestedToDeleteUsersSelector = state => {
  return state[MainApp].requestedToDeleteUsers;
};

export const deletedUsersSelector = state => {
  return state[MainApp].deletedUsers;
};

export const addressQuizSelector = state => {
  return state[MainApp].quizAddress;
};

export const productsSelector = state => {
  return state[MainApp].products;
};

export const modalUnlockModuleSelector = state => {
  return state[MainApp].unlockModuleModal;
};

export const productsLoadingSelector = state => {
  return state[MainApp].loading.products;
};

export const syncProductsLoadingSelector = state => {
  return state[MainApp].loading.syncProducts;
};

export const allClassGroupsSelector = state => {
  return state[MainApp].classManagement;
};

export const isLoadingAllClassGroupsSelector = state => {
  return state[MainApp].classManagement.loading;
};

export const classGroupUsersSelector = state => {
  return state[MainApp].classGroupUsers;
};

export const isLoadingClassGroupUsersSelector = state => {
  return state[MainApp].classGroupUsers.loading;
};

export const isLoadingEditClassGroupSelector = state => {
  return state[MainApp].editClassGroup.loading;
};

export const isLoadingMoveClassGroupSelector = state => {
  return state[MainApp].moveUsersBetweenClassGroups.loading;
};

export const placementTestQuestionsSelector = state =>
  state[MainApp].placementTestQuestions;

export const waitingListSelector = state => state[MainApp].waitingList;

export const reprovedAndDropoutListSelector = state =>
  state[MainApp].reprovedAndDropoutList;

export const confirmedListSelector = state => state[MainApp].confirmedList;

export const waitingToConfirmListSelector = state =>
  state[MainApp].waitingToConfirmList;

export const allGroupsSelector = state => {
  return state[MainApp].groups;
};

export const isLoadingAllGroupsSelector = state => {
  return state[MainApp].groups.loading;
};

export const allFAQsSelector = state => {
  return state[MainApp].faq;
};

export const isLoadingAllFAQsSelector = state => {
  return state[MainApp].faq.loading;
};

export const faqCategoriesSelector = state => {
  return state[MainApp].faq.categories;
};

export const publicFAQsSelector = state => {
  return state[MainApp].faq.publicFaqList || [];
};

export const publicCategoriesSelector = state => {
  return state[MainApp].faq.publicCategories || [];
};

export const isLoadingExportWaitingListSelector = state => {
  return state[MainApp].loading.exportReport;
};

export const themeSelector = state => {
  return state[MainApp].theme;
};

// Email Stats Selectors
export const emailStatsSelector = state => state[MainApp].emailStats;
export const emailSentQuantitySelector = state =>
  state[MainApp].emailSentQuantity;

// Email Logs Selectors
export const emailLogsSelector = state => state[MainApp].emailLogs;
export const emailLogsDataSelector = state => state[MainApp].emailLogs.data;
export const emailLogsPaginationSelector = state =>
  state[MainApp].emailLogs.pagination;
export const emailLogsLoadingSelector = state =>
  state[MainApp].emailLogs.loading;
export const emailLogsFiltersSelector = state =>
  state[MainApp].emailLogs.filters;
export const emailLogsExportingSelector = state =>
  state[MainApp].emailLogs.exporting;
export const emailLogsErrorSelector = state => state[MainApp].emailLogs.error;

// Discord Selectors
export const discordUserSelector = state => state[MainApp].discord.discordUser;
export const discordUserLoadingSelector = state =>
  state[MainApp].discord.loading;

// Discord Logs Selectors
export const discordLogsSelector = state => state[MainApp].discordLogs;
export const discordLogsLoadingSelector = state =>
  state[MainApp].discordLogs.loading;
export const discordLogHistorySelector = state =>
  state[MainApp].discordLogHistory;
export const discordLogHistoryLoadingSelector = state =>
  state[MainApp].discordLogHistory.loading;
export const isLoadingExportDiscordLogsSelector = state =>
  state[MainApp].loading.exportDiscordLogs;

// Discord Role Selectors
export const discordRoleSelector = state => state[MainApp].discordRole.data;
export const isLoadingDiscordRoleSelector = state =>
  state[MainApp].discordRole.loading;
export const discordRoleErrorSelector = state =>
  state[MainApp].discordRole.error;

// Enrollment Management Selectors
export const enrollStudentLoadingSelector = state =>
  state[MainApp].enrollStudent.loading;

export const markDropoutLoadingSelector = state =>
  state[MainApp].markDropout.loading;

export const classGroupsByGroupSelector = state =>
  state[MainApp].classGroupsByGroup;

// Enrollment Audit Logs Selectors
export const enrollmentAuditLogsSelector = state =>
  state[MainApp].enrollmentAuditLogs.list;

export const enrollmentAuditLogsLoadingSelector = state =>
  state[MainApp].enrollmentAuditLogs.loading;

export const enrollmentAuditLogsErrorSelector = state =>
  state[MainApp].enrollmentAuditLogs.error;
